import InquiryApi from '@apis/inquiry/InquiryApi';
import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@router/stackflow';
import { useQueryClient } from '@tanstack/react-query';

function useCloseInquiry(inquiryId: string) {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { pop } = useFlow();
  return () => {
    InquiryApi.closeInquiry(inquiryId)
      .then(() => {
        queryClient.invalidateQueries({ queryKey: queries.inquiry._def });
        toast.success('문의가 종료되었습니다.');
        pop();
      }).catch((e) => {
        console.error(e);
        toast.error('문의 종료에 실패했습니다.');
      });
  };
}

export default useCloseInquiry;
